const favUtil = {
  getFileIcon(ext) {
    const obj = {
      'doc': 'word',
      'docx': 'word',
      'jpg': 'picImg',
      'jpeg': 'picImg',
      'png': 'picImg',
      'gif': 'picImg',
      'bmp': 'picImg',
      'xls': 'pic_x',
      'xlsx': 'pic_x',
      'ppt': 'pic_p',
      'pptx': 'pic_p',
      'pdf': 'pdf',
      'zip': 'folder',
      'rar': 'folder',
      'mp4': 'video',
      'mpg': 'video',
      'mpeg': 'video',
      'rm': 'video',
      'rmvb': 'video',
      'avi': 'video',
      'flv': 'video',
      'wmv': 'video',
      'mp3': 'music',
      'ogg': 'music',
      'wma': 'music',
      'wav': 'music',
      'amr': 'music',
      'ape': 'music',
      'flac': 'music',
      'txt': 'diary',
      'default': 'pic_error'
    };
    if (obj[ext]) {
      return obj[ext]
    }
    return obj.default
  },
  getOrigin() {
    if (process.env.VUE_APP_BUILD_ENV === "sit" || process.env.VUE_APP_BUILD_ENV === "uat") {
      return process.env.VUE_APP_BASE_API
    }
    const origin = location.origin.includes("http") ? location.origin : process.env.VUE_APP_BASE_API
    return origin
  },
  getRequest() {
    let url = window.location.search;
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
      let str = url.substr(1);
      let strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
      }
    }
    return theRequest || '';
  },
  formatDateStr(date) {
    if (!date) {
      return ''
    }
    let currentDate = (new Date().toLocaleDateString()).split('/');
    let currentYear = currentDate[0];
    let currentMonth = currentDate[1].length == 1 ? '0' + currentDate[1] : currentDate[1];
    let currentDay = currentDate[2].length == 1 ? '0' + currentDate[2] : currentDate[2];
    let favoDate = date.split(' ')[0].split('-');
    let favoYear = favoDate[0]
    let favoMonth = favoDate[1]
    let favoDay = favoDate[2]
    if (currentYear == favoYear
      && currentMonth == favoMonth
      && currentDay == favoDay) {
      // 今天的时间 显示具体时:分:秒
      let time = date.split(' ')[1]
      return time.split('.')[0]
    } else if (currentYear == favoYear) {
      // 今年的时间 显示 月-日
      let time = date.split(' ')[0]
      return time.split('-')[1] + '-' + time.split('-')[2]
    } else {
      // 非今年的时间
      // 显示 具体的 年-月-日
      return date.split(' ')[0];
    }
  },
  sizeFormat(value) { //文件大小格式化
    var i = -1;
    let size = !isNaN(value) ? parseInt(value) : 0,
      unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

    if (size > 0) {
      while (size >= 1) {
        size /= 1024;
        i++;
      }
      if (i < unit.length) {
        return (size * 1024).toFixed(2) + unit[i];
      }
      return false;
    }
    return 0 + 'B';
  },
  preIconUrl(str, flag) {
    const host = this.getOrigin()
    if (str && str.indexOf('http') == 0) {
      return str;
    } else {
      if (flag == 'headIcon') {
        return host + '/space/c/photo/load?id=' + str;
      } else {
        // 从url链接中获取ticket
        const ticket = this.getUrlTicket()
        return host + '/docrest/file/downloadfile/' + str + '?w280&ticket=' + ticket + '&appId=10611';
      }
    }
  },
  getUrlTicket() {
    const url = window.location.href
    const ticket = url.match(/ticket=([^&]+)/)
    return ticket ? ticket[1] : ''
  },
  filterHtml(str) {
    return str.replace(/(<([^>]+)>)/ig, '')
  },
  escape(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
  },
  specialCharacter(str) {
    str = str.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    return str
  },
  isMobile() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    return flag || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  },
  // 运行环境
  env() {
    let _env = envConfig[location.host] || 'local'
    console.log('env -> ', _env)
    return _env
  },
  // 获取设备参数
  getUA(name) {
    var reg = new RegExp('(;|^)\\s*' + name + '\\s*:([^;]*)')
    var result = navigator.userAgent.match(reg)
     console.log('result -> ', result, name, navigator.userAgent)
    if (result && result.length === 3) {
      return result[2]
    }
  },
  // 获取语言全称
  getLanguage() {
    var language = this.getUA('langV2') || navigator.language
    console.log('language -> ', language, navigator.language)
    // 中文判断逻辑
    if (language.indexOf('zh') !== -1) {
      return 'zh-CN'
    }
    if (language.indexOf('pt-br') !== -1) {
      return 'pt-br'
    }
    // 其他语言默认按英文处理
    return 'en-US'
  },
  // 获取语言简写
  getLang() {
    var language = this.getLanguage()
    return language.split('-')[0]
  }
}

export const contentTypes = { // 消息类型
  txt: 1, // 1 文本
  pic: 2, // 2 图片
  voice: 4, // 4 语音
  video: 8, // 8 视频
  file: 16, // 16 文件
  link: 32, // 32 链接
  app: 64, // 64 应用
  merge: 128, // 128 合并消息
  vote: 256, // 256 微博、投票
  richTxt: -1000, // 富文本,
  richMsg: 0
}
export const dataTypes = {
  simple: 1, // 简单内容
  // mirror: 1, // 镜像内容
  richText: 2, // 富文本内容
}
export const sourceTypes = { // 消息来源
  unknow: 1, // '未知来源',
  yzjGroup: 2, // '云之家群组消息',
  yzjBlog: 3, // '云之家同事圈',
  wechat: 4, // '微信文章',
  note: 5, // '个人笔记',
  yzj: 6, // '云之家'
  info: 7 // 知识中心
}

/** 
* @desc 函数防抖 
* @param func 回调函数 
* @param delay 延迟执行毫秒数 
*/ 
export const debounce = (func, delay) => { 
  let timer;  // 定时器

  return function () { 
      let context = this;  // 记录 this 值,防止在回调函数中丢失
      let args = arguments;  // 函数参数

      //如果定时器存在，则清除定时器(如果没有,也没必要进行处理)
      timer ? clearTimeout(timer) : null; 

      timer = setTimeout(() => { 
          // 防止 this 值变为 window
          func.apply(context, args) 
      }, delay);
  } 
} 

export const convertImgToBase64 = (url, callback, outputFormat, maxWidth) => {
  var canvas = document.createElement('CANVAS');
  var ctx = canvas.getContext('2d');
  var img = new Image();
  img.crossOrigin = 'Anonymous';
  var width = maxWidth;

  img.onload = function () {
    canvas.height = img.height;
    canvas.width = img.width;

    if (width) {
      canvas.height = width * (img.height / img.width);
      canvas.width = width;
    }

    // //判断如果图片太大，就压缩
    // if(img.height > maxHeight){
    //     canvas.height = maxHeight;
    //     canvas.width *= maxHeight / img.height ;
    // }

    ctx.drawImage(img, 0, 0,);
    var dataURL = canvas.toDataURL(outputFormat || 'image/png');
    callback.call(this, dataURL);
    canvas = null;
  };
  img.src = url;
}
// 环境配置
const envConfig = {
  'mtp-uat.wanyol.com': 'uat',
  'mtp-test.myoas.com': 'test',
  'mtp.myoas.com': 'release',
  'mtp.oppowork.com': 'release',
  'mtp-dev.myoas.com': 'dev'
}

export const appId = "10611"
export const appName = "我的收藏"
export const linkBase64_blue = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjQ2MjkwMDk1NjY2IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjY4ODUiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTQ1NS43OTgxNTQgMjIwLjYzMjYxNWM5Mi45MDgzMDgtOTIuOTQ3NjkyIDI0NS45NTY5MjMtODkuNzk2OTIzIDM0MS44OTc4NDYgNi4xODMzODUgOTMuODE0MTU0IDkzLjgxNDE1NCA5OC45MzQxNTQgMjQyLjIxNTM4NSAxMi4yNDg2MTUgMzM1LjYzNTY5MmwtNi4wMjU4NDYgNi4zMDE1MzktNTguODAxMjMxIDU4Ljc2MTg0Ni00MS43NDc2OTItNDEuNzQ3NjkyIDU4Ljc2MTg0Ni01OC44MDEyMzFjNjkuNDM1MDc3LTY5LjQzNTA3NyA2Ny4wNzItMTg1LjEwNzY5Mi02LjE4MzM4NC0yNTguMzYzMDc3LTcxLjIwNzM4NS03MS4yNDY3NjktMTgyLjU0NzY5Mi03NS40NjA5MjMtMjUyLjQ5NDc3LTExLjgxNTM4NWwtNS45MDc2OTIgNS41OTI2MTYtNTguNzYxODQ2IDU4LjgwMTIzLTQxLjc4NzA3Ny00MS43NDc2OTIgNTguODAxMjMxLTU4LjgwMTIzMXpNMjc5LjM5NDQ2MiAzOTYuOTk2OTIzbDQxLjc4NzA3NiA0MS43NDc2OTItNTguODAxMjMgNTguODAxMjMxYy02OS40MzUwNzcgNjkuNDc0NDYyLTY3LjAzMjYxNSAxODUuMTQ3MDc3IDYuMTgzMzg0IDI1OC4zNjMwNzcgNzEuMjQ2NzY5IDcxLjI0Njc2OSAxODIuNTQ3NjkyIDc1LjQ2MDkyMyAyNTIuNDk0NzcgMTEuODE1Mzg1bDUuOTA3NjkyLTUuNTkyNjE2IDU4LjgwMTIzMS01OC44MDEyMyA0MS43NDc2OTIgNDEuNzQ3NjkyLTU4LjgwMTIzMSA1OC44NDA2MTVjLTkyLjkwODMwOCA5Mi45MDgzMDgtMjQ1Ljk1NjkyMyA4OS43MTgxNTQtMzQxLjg5Nzg0Ni02LjIyMjc2OS05My44MTQxNTQtOTMuNzc0NzY5LTk4LjkzNDE1NC0yNDIuMjE1Mzg1LTEyLjI0ODYxNS0zMzUuNjM1NjkybDYuMDY1MjMtNi4zMDE1MzkgNTguNzYxODQ3LTU4Ljc2MTg0NnogbTM1OC45NTEzODQtNTIuNjE3ODQ2bDQxLjc0NzY5MiA0MS43ODcwNzctMjkzLjkyNzM4NCAyOTMuOTY2NzY5LTQxLjc0NzY5Mi00MS43NDc2OTIgMjkzLjkyNzM4NC0yOTQuMDA2MTU0eiIgcC1pZD0iNjg4NiIgZmlsbD0iIzM5NzlFMSI+PC9wYXRoPjwvc3ZnPg=='
export const shimoLink_blue = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjYzNjQ0NzM4OTg4IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjI4MjU2IiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik02MzguOTEyIDE0Mi41MjhhMzcuNzYgMzcuNzYgMCAwIDEgMjYuMjQgMTAuOTQ0bDE2NS44ODggMTcxLjMyOGEzNi4wOTYgMzYuMDk2IDAgMCAxIDExLjY0OCAyNi40OTZ2NDk3Ljc5MmEzNi4yODggMzYuMjg4IDAgMCAxLTM2LjI4OCAzNi4yMjRIMjE3LjkyYTM2LjM1MiAzNi4zNTIgMCAwIDEtMzYuNjA4LTM2LjIyNFYxNzguNzUyYzAtMjAuNjA4IDE2Ljk2LTM2LjIyNCAzNi42MDgtMzYuMjI0eiBtLTYyLjIwOCA2My45MzZIMjQ1LjMxMnY2MTQuODQ4aDUzMy4zMTJWNDI1LjQwOGgtMTY1Ljc2YTM2LjA5NiAzNi4wOTYgMCAwIDEtMzUuNjQ4LTMwLjcybC0wLjQ0OC01Ljc2VjIwNi41Mjh6TTUxMiA2NzUuMTM2djY0SDM0MS4xMnYtNjRINTEyeiBtMTcxLjI2NC0xNDkuMTJ2NjRIMzQxLjEydi02NGgzNDIuMjA4eiBtLTQyLjU2LTMwNS43MjhsMC4wNjQgMTQxLjEyaDEzNi43MDRsLTEzNi43NjgtMTQxLjEyeiIgcC1pZD0iMjgyNTciIGZpbGw9IiMzODc5RTEiPjwvcGF0aD48L3N2Zz4='
export default favUtil;
